const languageBasePath = '/settings/languages';

const LanguageConst = {
    basePath: languageBasePath,
};

export default LanguageConst;
